import logo from "assets/img/logo.svg";
import miniLogo from "assets/img/miniLogo.svg";
import publicBackgroundImg from "assets/img/login-bg.jpg";

const defaultFont = {
  fontFamily: "SparRg, Arial",
  fontSize: 14,
  lineHeight: "1em",
};

const palette = {
  primary: {
    main: "#EE0000",
  },
  secondary: {
    main: "#666666",
  },
  text: {
    dark: "rgb(3, 19, 3)",
    white: "rgb(255, 255, 255)",
    darkGrey: "rgb(169,169,169)",
    highlight: "rgb(36, 76, 140)",
    primary: "#666666",
  },
  sideMenu: {
    bkColor: "#666666",
    activeLinkColor: "#fff",
    activeBkColor: "#565656",
    hoverBgColor: "rgba(200, 200, 200, 0.2)",
    color: "#ffffff",
    bkOpacity: "1",
    focusBgColor: "#26C6DA",
  },
  topBar: {
    bkColor: "#ffffff",
    activeBkColor: "#565656",
  },
  timColors: {
    primary: "#555555",
    primaryRGBA: "rgba(85, 85, 85, 1)",
    warningColor: "#ff9800",
    dangerColor: "#ee0000",
    successColor: "#4caf50",
    infoColor: "#00acc1",
    blueColor: "#26C6DA",
    themeColor: "#666666",
    themeColorRGBA: "rgba(85, 85, 85, 1)",
    themeShadowColor: "#26C6DA",
    themeShadowColorRGBA: "#555555",
    roseColor: "#e91e63",
    grayColor: "#999999",
    blackColor: "#000",
  },
  snackbar: {
    infoBgColor: "#ccf1ff",
    infoColor: "#555555",
    dangerBgColor: "#ee0000",
    dangerColor: "#ffffff",
    successBgColor: "#36b37e",
    successColor: "#ffffff",
    warningBgColor: "#ff9800",
    warningColor: "#ffffff",
  },
  card: {
    gray500: "#D7D7D7",
    orange800: "#B35500",
    orange500: "#fb8c00",
    orange400: "#ffa726",
    green500: "#43a047",
    green400: "#66bb6a",
    blue500: "#26c6da",
    blue400: "#00acc1",
    red400: "#FF6666",
    red500: "#FF5555",
  },
  amount: {
    positive: "#01b25a",
    negative: "#f55",
    faded: "#60768f",
    active: "#ee0000",
  },
  bg: {
    main: "#e5e5e5", //"#eee"
  },
  activeColor: "#555555",
  button: {
    theme: "#26C6DA",
    themeHoverBk: "transparent",
    themeHoverColor: "#26C6DA",
    themeHoverShadow:
      "0 2px 2px 0 rgba(0, 188, 212, 0.42), 0 3px 1px -2px rgba(0, 188, 212, 0.12), 0 1px 5px 0 rgba(0, 188, 212, 0.2)",
    themeShadow:
      "0 2px 2px 0 rgba(0, 188, 212, 0.14), 0 3px 1px -2px rgba(0, 188, 212, 0.2), 0 1px 5px 0 rgba(0, 188, 212, 0.12)",
  },
};

/**
 * @description Is used only for fallback
 */
export const theme = {
  logo,
  miniLogo,
  publicBackgroundImg: publicBackgroundImg,
  input: {
    height: "1.1875em",
  },
  defaultFont,
  palette,
  typography: {
    ...defaultFont,
    useNextVariants: true,
    htmlFontSize: 14,
    fontWeightMedium: 300,
    button: {
      ...defaultFont,
      textAlign: "center",
      fontStretch: "normal",
      fontStyle: "normal",
    },
    body: {
      ...defaultFont,
      fontSize: 14,
    },
  },
  overrides: {
    MuiCollapse: {
      entered: {
        height: "auto",
        overflow: "visible",
      },
    },
    MuiCardHeader: {
      content: {
        width: "100%",
      },
    },
    MuiDivider: {
      root: {
        height: "2px",
      },
    },
    MuiTablePagination: {
      actions: {
        marginLeft: 0,
      },
      toolbar: {
        paddingLeft: 0,
      },
    },
  },
  table: {
    main: {
      marginTop: "15px",
      marginBottom: "15px",
      borderSpacing: 0,
    },
    tableHeader: {
      textAlign: "left",
      backgroundColor: "#f0fbff",
      padding: "10px",
      color: "#555555",
      borderBottom: "1px solid #ddd",
    },
    tableContent: {
      textAlign: "left",
      padding: "10px ",
      borderBottom: "1px solid #eee",
    },
    itemSelected: {
      background: "#ccf1ff",
      color: "#555555",
    },
  },
  autoComplete: {
    valueContainer: {
      display: "flex",
      flexWrap: "wrap",
      flex: 1,
      alignItems: "center",
      paddingBottom: "5px",
    },
    input: {
      fontFamily: "Source Sans Pro !important",
      fontSize: "14px !important",
      fontWeight: "normal !important",
      fontStretch: "normal !important",
      fontStyle: "normal !important",
      lineHeight: "1.29 !important",
      color: "#a8a8a8 !important",
    },
    selectedInputColor: "#000",
  },
  card: {
    height: "auto",
    width: "auto",
    borderRadius: "5px",
    boxShadow: "0 2px 9px 0 rgba(0, 0, 0, 0.14)",
    backgroundColor: "#ffffff",
  },
  header: {
    title: {
      paddingLeft: "5px",
      borderRadius: "3px",
      textTransform: "none",
      //fontWeight: "bold",
      color: palette.primary.secondary,
      "&:hover,&:focus": {
        background: "transparent",
      },
    },
    titleMobile: {
      paddingLeft: "5px",
      borderRadius: "3px",
      textTransform: "none",
      //fontWeight: "bold",
      color: palette.primary.secondary,
      "&:hover,&:focus": {
        background: "transparent",
      },
    },
    button: {
      minHeight: "65px",
      margin: "2px",
      textTransform: "capitalize",
      backgroundColor: palette.topBar.bkColor + " !important",
      boxShadow: "none",
      color: palette.topBar.activeBkColor,
      fontFamily: defaultFont.fontFamily,
      fontSize: defaultFont.fontSize,
    },
  },
  main: {
    container: {
      minHeight: "calc(100vh - 244px)",
      "@media (max-width: 480px)": {
        padding: 0,
      },
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    content: {
      position: "relative",
      header: {
        height: "110px",
      },
      footer: {
        height: "134px",
      },
    },
    footer: {
      height: "67px",
      backgroundColor: "#ffffff",
      boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px #555555",
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
    },
  },
  sidebar: {
    wrapper: {
      height: "calc(100vh - 115px)",
    },
  },
};
